import React from 'react';
import PropTypes from 'prop-types';
import Spin from './Spin.js';

export default Spin;

Spin.defaultProps = {
  size: 'default',
  spinning: true
};
Spin.PropTypes = {
  /** 延迟显示加载效果的时间（防止闪烁） */
  delay: PropTypes.number,
  /** 加载指示符 */
  indicator: PropTypes.node,
  /** 组件大小，可选值为 small default large */
  size: PropTypes.oneOf(['small', 'default', 'large']),
  /** 是否为加载中状态 */
  spinning: PropTypes.bool,
  /** 当作为包裹元素时，可以自定义描述文案 */
  tip: PropTypes.string,
  /** 包装器的类属性 */
  wrapperClassName: PropTypes.string
};
